import React from "react";
import MilesPointsRedeemCard from "./MilesPointsRedeemCard";

function MilesPointsDashboardsRedeemCards() {
  const items = [
    {
      title: "30 Days Subscription Extension",
      amount: "5,000",
      description:
        "Keep full access to all platform features without any interruption.",
      sufficient: true,
    },
    {
      title: "Wallet Top-Up",
      amount: "10,000",
      description:
        "This credit can be applied toward bookings or service fees within the platform.",
      sufficient: false,
    },
    {
      title: "Wallet Top-Up",
      amount: "10,000",
      description:
        "This credit can be applied toward bookings or service fees within the platform.",
      sufficient: true,
    },
    {
      title: "Wallet Top-Up",
      amount: "10,000",
      description:
        "This credit can be applied toward bookings or service fees within the platform.",
      sufficient: false,
    },
  ];
  return (
    <div className="w-full py-4 bg-white flex items-center justify-center">
      <div className="w-[96%] overflow-x-scroll gap-4 flex px-2 py-4 custom-scrollbar">
        {items?.map((item, index) => (
          <MilesPointsRedeemCard key={index} item={item} />
        ))}
      </div>
    </div>
  );
}

export default MilesPointsDashboardsRedeemCards;
